import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Article } from './models/article';
import { environment } from '../environments/environment';

const newsletterCollection: string = 'newsletter';
const articleTable: string = 'blog';
const anon_key: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impza3h0emlvendsbHlqcHhveW5lIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzYzNjIyNTEsImV4cCI6MTk5MTkzODI1MX0.Pw4MQ-Z99l4yb3l0rs65Os6b_nyq7cFrNLxKHFSEAMM';
const supabase_url: string = 'https://api.brandripplr.com';

@Injectable({
    providedIn: 'root',
  })
export class AppService {
    articles!: Article[];
    article!: Article;
    // private supabase: SupabaseClient

    constructor(private afs: AngularFirestore) { 
        // this.supabase = createClient(environment.supabase.supabaseUrl, environment.supabase.supabaseKey);   
    }

    addToNewsletter(email: string) {
        console.log(email);
        return new Promise<any>((resolve, reject) => {
            this.afs
                .collection(newsletterCollection)
                .doc(email)
                .set({ email, })
                .then(res => { }, err => reject(err));
        });
    }
    async getArticleBySlug(slug: string): Promise<Article> {
        try {
            const res = await fetch(`${supabase_url}/rest/v1/${articleTable}?slug=eq.${encodeURIComponent(slug)}&select=*`, {
                headers: {
                    'apikey': anon_key,
                    'Authorization': `Bearer ${anon_key}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });
            
            if (!res.ok) {
                const errorText = await res.text();
                console.error('API error response:', errorText);
                throw new Error(`HTTP error! status: ${res.status}, response: ${errorText}`);
            }
            
            const articles = await res.json();
            if (!articles || articles.length === 0) {
                throw new Error('Article not found');
            }
            
            return articles[0];
        } catch (error) {
            console.error('Error fetching article:', error);
            throw error;
        }
    }

    async getArticles(type: string): Promise<Article[]> {        
        try {
            const res = await fetch(`${supabase_url}/rest/v1/${articleTable}?project=eq.brandripplr&status=eq.published&type=eq.${type}`, {
                headers: {
                    'apikey': anon_key,
                    'Authorization': `Bearer ${anon_key}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });
            
            
            if (!res.ok) {
                const errorText = await res.text();
                console.error('API error response:', errorText);
                throw new Error(`HTTP error! status: ${res.status}, response: ${errorText}`);
            }
            
            const responseData = await res.json();
            this.articles = Array.isArray(responseData) ? responseData : [];
            return this.articles;
        } catch (error) {
            console.error('Error fetching articles:', error);
            return [];
        }
    }
    async getArticle(slug: string): Promise<Article> {
        try {
            const res = await fetch(`${supabase_url}/rest/v1/${articleTable}?slug=eq.${encodeURIComponent(slug)}`, {
                headers: {
                    'apikey': anon_key,
                    'Authorization': `Bearer ${anon_key}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
            });
            
            if (!res.ok) {
                const errorText = await res.text();
                console.error('API error response:', errorText);
                throw new Error(`HTTP error! status: ${res.status}, response: ${errorText}`);
            }
            
            const articles = await res.json();
            if (!articles || articles.length === 0) {
                throw new Error('Article not found');
            }
            
            return articles[0];
        } catch (error) {
            console.error('Error fetching article:', error);
            throw error;
        }
    }
}
